var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._l(_vm.allApplicants, function (applicant, applicantIndex) {
        return _c(
          "div",
          {
            key:
              _vm.applicantNameFromIndex(applicantIndex) + "-" + applicantIndex,
          },
          [
            _vm.isApplicantVisibleFromFillOut(applicant.id)
              ? _c(
                  "page-summary-section-group-layout",
                  { attrs: { "show-divider": "" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex justify-content-end pr-0 font-sm",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "pretty p-icon p-jelly p-smooth p-curve",
                              },
                              [
                                _c("input", {
                                  attrs: {
                                    id: "tutorial",
                                    "value.sync":
                                      "applicant['personal-details']['is-retired']",
                                    name: "tutorial",
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked:
                                      applicant["personal-details"][
                                        "is-retired"
                                      ],
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setApplicantAsRetired(
                                        applicant,
                                        applicantIndex
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "state p-success" }, [
                                  _c("i", { staticClass: "icon fa fa-check" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticClass: "clickable text-primary" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-standalone.pages.incomeHistory.retiredHomemaker"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex justify-content-between my-3",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "section-title",
                              { attrs: { "title-type": "subtitle" } },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.applicantNameFromIndex(
                                          applicantIndex
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link text-primary p-0",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAddIncomeSource(
                                      applicantIndex,
                                      applicant.id
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            + " +
                                    _vm._s(_vm.addIncomeButtonText(applicant)) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.applicantHasEmployment(applicant["employment"]) &&
                    !applicant["personal-details"]["is-retired"]
                      ? _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "12" } }, [
                              _c("h6", { staticClass: "text-light-gray" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      applicantIndex
                                        ? _vm.$t(
                                            "application-standalone.pages.incomeHistory.applicantHasNoIncomes"
                                          )
                                        : _vm.$t(
                                            "application-standalone.pages.incomeHistory.youHaveNoIncomes"
                                          )
                                    ) +
                                    "\n          "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.showErrors &&
                              !applicant["personal-details"]["is-retired"]
                                ? _c(
                                    "div",
                                    { staticClass: "text-danger d-flex" },
                                    [
                                      _c("application-section-error-icon", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          id:
                                            "error-no-incomes-" +
                                            applicantIndex,
                                          "show-errors": _vm.showErrors,
                                          "no-tooltip": "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-standalone.pages.incomeHistory.applicantMustHaveOneIncomeSource"
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("h6", { staticClass: "text-light-gray" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-standalone.pages.incomeHistory.minimumHistoryRecommended"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._l(
                          applicant["employment"],
                          function (employment, employmentIndex) {
                            return _c(
                              "b-row",
                              { key: employmentIndex, staticClass: "mb-3" },
                              [
                                _c("b-col", { attrs: { cols: "5" } }, [
                                  employment["employer-name"]
                                    ? _c("span", { staticClass: "bold" }, [
                                        _vm._v(
                                          _vm._s(
                                            employment["employer-name"] ===
                                              "Retired/Homemaker"
                                              ? _vm.$t(
                                                  "application-standalone.pages.incomeHistory.retiredHomemaker"
                                                )
                                              : _vm.$t(
                                                  "application-standalone.pages.incomeHistory.yourJob"
                                                ) +
                                                  " " +
                                                  employment["employer-name"]
                                          )
                                        ),
                                      ])
                                    : _c("span", { staticClass: "bold" }, [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _vm.ordinalIndex(
                                                employmentIndex + 1
                                              )
                                            ) +
                                            "\n            " +
                                            _vm._s(
                                              _vm.$t(
                                                "application-standalone.pages.incomeHistory.incomeSource"
                                              )
                                            )
                                        ),
                                      ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("span", { staticClass: "mr-1" }, [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm._f("formatMoneyValueLong")(
                                                  employment["income-amount"]
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.isIncomeInvalid(
                                          applicantIndex,
                                          employmentIndex
                                        ) &&
                                        !applicant["personal-details"][
                                          "is-retired"
                                        ]
                                          ? _c(
                                              "application-section-error-icon",
                                              {
                                                attrs: {
                                                  id:
                                                    "error-income-" +
                                                    applicantIndex +
                                                    "-" +
                                                    employmentIndex,
                                                  "show-errors": _vm.showErrors,
                                                  "is-first-item":
                                                    _vm.isFirstError(
                                                      applicantIndex,
                                                      employmentIndex,
                                                      false
                                                    ),
                                                },
                                              }
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            employment["current-job"]
                                              ? _vm.$t("global.words.current")
                                              : ""
                                          ) +
                                          "\n          "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                employment["employer-name"] !==
                                "Retired/Homemaker"
                                  ? _c("b-col", { attrs: { cols: "auto" } }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-danger mr-2 my-lg-0 my-3",
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDeletionModal({
                                                applicantIndex: applicantIndex,
                                                employmentIndex:
                                                  employmentIndex,
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t("global.words.delete")
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary text-capitalize skip-disable-all-inputs",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleNavigation(
                                                applicantIndex,
                                                employmentIndex,
                                                applicant.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm.allowEdit
                                            ? _c("icon", {
                                                staticClass:
                                                  "text-primary mr-1",
                                                attrs: { name: "pencil" },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(_vm.editButtonText) +
                                              "\n          "
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                    _vm._v(" "),
                    _vm.additionalIncomeVisibleByApplicant(applicantIndex)
                      ? [
                          _c(
                            "b-row",
                            { staticClass: "column-divider-top pt-3 mb-3" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex justify-content-end",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-link text-primary p-0",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleAddAdditionalIncome(
                                            applicantIndex,
                                            applicant.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              +\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-standalone.pages.otherIncome.addAdditionalIncome"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex justify-content-end mb-3 text-muted small",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-standalone.pages.otherIncome.additionalInformation"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.applicantHasAdditionalIncome(
                            applicant["other-income"]
                          )
                            ? _c(
                                "b-row",
                                { staticClass: "mt-3" },
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "h6",
                                      { staticClass: "text-light-gray" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              applicantIndex
                                                ? _vm.$t(
                                                    "application-standalone.pages.otherIncome.applicantHasNoIncomes"
                                                  )
                                                : _vm.$t(
                                                    "application-standalone.pages.otherIncome.youHaveNoIncomes"
                                                  )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._l(
                                applicant["other-income"],
                                function (otherIncome, otherIncomeIndex) {
                                  return _c(
                                    "b-row",
                                    {
                                      key: "other-income-" + otherIncomeIndex,
                                      staticClass: "mb-3",
                                    },
                                    [
                                      _c("b-col", { attrs: { cols: "5" } }, [
                                        otherIncome.type
                                          ? _c(
                                              "span",
                                              { staticClass: "bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application-form." +
                                                        otherIncome.type
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              { staticClass: "bold" },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      _vm.ordinalIndex(
                                                        otherIncomeIndex + 1
                                                      )
                                                    ) +
                                                    "\n              " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "application-standalone.pages.otherIncome.additionalIncomeSource"
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mr-1" },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatMoneyValueLong"
                                                        )(otherIncome["amount"])
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.isAdditionalIncomeInvalid(
                                                applicantIndex,
                                                otherIncomeIndex
                                              )
                                                ? _c(
                                                    "application-section-error-icon",
                                                    {
                                                      attrs: {
                                                        id:
                                                          "error-other-income-" +
                                                          applicantIndex +
                                                          "-" +
                                                          otherIncomeIndex,
                                                        "show-errors":
                                                          _vm.showErrors,
                                                        "is-first-item":
                                                          _vm.isFirstError(
                                                            applicantIndex,
                                                            otherIncomeIndex,
                                                            true
                                                          ),
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "application-form.additional-income"
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "auto" } }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-danger mr-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openDeletionModal(
                                                  {
                                                    applicantIndex:
                                                      applicantIndex,
                                                    otherIncomeIndex:
                                                      otherIncomeIndex,
                                                  },
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.$t("global.words.delete")
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary text-capitalize skip-disable-all-inputs",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleNavigation(
                                                  applicantIndex,
                                                  otherIncomeIndex,
                                                  applicant.id,
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.allowEdit
                                              ? _c("icon", {
                                                  staticClass:
                                                    "text-primary mr-1",
                                                  attrs: { name: "pencil" },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.editButtonText) +
                                                "\n            "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("remove-component-modal", {
        ref: "removeComponentModal",
        attrs: { text: _vm.modalText },
        on: { accept: _vm.handleDelete },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }